import { useGlobalStore } from "@/stores/useGlobalStore";
import { storeToRefs } from "pinia";

export default defineNuxtPlugin(() => {
    const config = useRuntimeConfig();
    const baseURL = config.public.apiBase;
    const globeStore = useGlobalStore();
    const { accessToken } = storeToRefs(globeStore);

    const baseFetch = $fetch.create({
        baseURL,
        onRequest({ options }) {
            const token = accessToken.value || false;
            console.log("calling On request before API call Token ====", token);
            const headers = new Headers(options.headers);
            if (token) {
                headers.set('Authorization', `Bearer ${token}`);
            } else {
                headers.delete('Authorization');
            }
            options.headers = headers;
        }
    });

    const apiFetcher = async (request: any, options?: any) => {
        try {
            return await baseFetch(request, options);
        } catch (error: any) {
            if (error.response?.status === 401) {
                // Ignore 401s that are already coming from the refresh endpoint
                if (request.toString().includes('token/refresh')) {
                    globeStore.clearAll();
                    navigateTo('/login');
                    throw error;
                }

                const refresh = globeStore.getRefreshToken;
                if (!refresh) {
                    globeStore.clearAll();
                    // alert("Session expired, please login.");
                    navigateTo('/login');
                    throw error;
                }

                try {
                    // Make a raw request to refresh the token to avoid interceptor loops
                    const refreshRes = await $fetch<any>(`${baseURL}/user/token/refresh/`, {
                        method: 'POST',
                        body: { refresh: refresh }
                    });

                    if (refreshRes && refreshRes.access) {
                        // Update the store with new tokens
                        const newRefresh = refreshRes.refresh || refresh;
                        globeStore.updateToken(refreshRes.access, newRefresh);

                        // Update the request header with the new token
                        const headers = new Headers(options?.headers || {});
                        headers.set('Authorization', `Bearer ${refreshRes.access}`);

                        const newOptions = { ...options, headers };

                        // Replay the original request using baseFetch
                        return await baseFetch(request, newOptions);
                    }
                } catch (e: any) {
                    console.error("Silent refresh failed", e);
                }

                // If we get here, the refresh failed
                globeStore.clearAll();
                // alert("Session expired, please login.");
                navigateTo('/login');
            }
            throw error;
        }
    };

    return {
        provide: {
            apiFetch: apiFetcher as typeof $fetch
        }
    };
});